import { createContext, useContext, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { STRINGS } from "./strings";
import { LANGS, langFromPath, buildPath, alternatePath } from "./routes";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const lang = langFromPath(pathname);

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("hcm_lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      langs: LANGS,
      t: STRINGS[lang] || STRINGS.en || STRINGS.es,
      /** localized content getter for CMS {es,en,...} objects, with fallback chain */
      L: (obj, fallback = "") => (obj && (obj[lang] || obj.es || obj.en)) || fallback,
      path: (key, params) => buildPath(key, lang, params),
      altPath: (target) => alternatePath(pathname, target),
      switchLang: (target) => navigate(alternatePath(pathname, target)),
    }),
    [lang, pathname, navigate]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
